// store/index.js

import Vue from 'vue'
import Vuex from 'vuex'

import userModule from './modules/user';
import commonModule from './modules/common';
import sseModule from './modules/sse';
import GlobalConstants from "../components/common/global.constants";
import apiAxios from '@/services/axios/api.axios';
import _ from "lodash";
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user: userModule,
        common: commonModule,
        sse: sseModule
    },
    state: {
        loginUser : {               // Login User Info
            siteCd : null,
            userNm : null,
            curCmpnId: null,
        },
        sub_domain: null,          // Sub doamin
        CMPN_MENUl_AUTH: null,      // Company Menu Auth
        SECURITY_MENU_AUTH: null,   // Security Menu Auth
        CONSOLE_MENU_AUTH: null,    // Console Menu Auth
        templateList: null,         // Policy template list
        GOV_MENU_AUTH: null,        // Governance Menu Auth
        svcMenuList:null,           // Available Service Menu List
        vendorInfo: null,           // Cloud Vendor Information
        ACCESS_TOKEN_KEY : GlobalConstants.ACCESS_TOKEN_DEV ,
        homepageInfo: null,
        allAccount:[]               // All Account
        // logo: {
        //
        // }
    },
    getters: {
        // getLogo() {
        //     return this.state.logo
        // }
        getMenuAuth: state => {
            return state.GOV_MENU_AUTH;
        },
        getAllAccountFilterData: state => {
            return state.allAccount.length > 0 ? _.unionBy(state.allAccount.map(ac => ({ 'key': ac.accId, 'val': ac.accAlias, 'vendor': ac.vendor })), "key") : [];
        }
    },
    mutations: {
        setLoginUser(state, loginUser) {
            state.loginUser = loginUser
        },
        // setWhiteLabelLogo(state, logo) {
        //     state.logo = logo
        // },
        setSubDomain(state, subDomain) {
            state.sub_domain = subDomain
        },
        setUserCurCompany(state, cmpn) {
            state.loginUser.curCmpnId = cmpn.cmpnId
            state.loginUser.curCmpnNm = cmpn.cmpnNm
        },
        setTemplateList(state, data) {
            state.templateList = data.templateList;
        },
        setGovMenuAuth(state, data) {
            state.GOV_MENU_AUTH = data.GOV_MENU_AUTH
        },
        setSvcMenuList(state, data) {
            state.svcMenuList = data.svcMenuList
        },
        setVendorInfo(state, data) {
            state.vendorInfo = data.vendorInfo
        },
        setTokenKey(state, tokenKey){
            state.ACCESS_TOKEN_KEY = tokenKey;
        },
        setHomepageInfo(state, homepageInfo){
            state.homepageInfo = homepageInfo;
        },
        setAllAccount(state, allAccount){
            state.allAccount = allAccount.allAccount;
        }
    },
    actions:{
        async selectTemplateList({commit},cmpnId){
            const url = `/governance/tmplt/list`
            let header = {
                'cmpnId': cmpnId
            };

            return apiAxios.post(url, JSON.stringify(header))
                .then(result => {
                    if (result.data.status == 'ok') {
                        let templateList = [];
                        for (let tmplt of result.data.result) {
                            if (tmplt.basicFormation != '') {
                                tmplt.basicFormation = JSON.parse(tmplt.basicFormation)
                                tmplt.en = JSON.parse(tmplt.en)
                                tmplt.ko = JSON.parse(tmplt.ko)
                                tmplt.zh = JSON.parse(tmplt.zh)

                                templateList.push(tmplt)
                            }
                        }
                        commit('setTemplateList', {templateList: templateList})
                    }
                });
        },
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js